import { Edit, Print, List, Details, Create } from "../Components/index.js";

export default [
    {
        path: "/letter/outgoing",
        component: List,
        name: "letter.outgoing",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/letter/outgoing/:id/view",
        component: Details,
        name: "letter.outgoing.view",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/letter/outgoing/:id/edit",
        component: Edit,
        name: "letter.outgoing.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/letter/outgoing/:id/print",
        component: Print,
        name: "letter.outgoing.print",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/letter/outgoing/create",
        component: Create,
        name: "letter.outgoing.create",
        meta: {
            requiresAuth: true,
        },
    },
];
